import ApiService from '@/common/api/api.service';

const FichaSaudeService = {
  async salvarFicha(fichaSaude) {
    fichaSaude.tiposDeficiencias = [];
    if (fichaSaude.deficienciaAuditiva)
      fichaSaude.tiposDeficiencias.push('Auditiva');
    if (fichaSaude.deficienciaFisica)
      fichaSaude.tiposDeficiencias.push('Fisica');
    if (fichaSaude.deficienciaIntelectual)
      fichaSaude.tiposDeficiencias.push('Intelectual');
    if (fichaSaude.deficienciaMultipla)
      fichaSaude.tiposDeficiencias.push('Multipla');
    if (fichaSaude.deficienciaPsicossocial)
      fichaSaude.tiposDeficiencias.push('Psicossocial');
    if (fichaSaude.deficienciaVisual)
      fichaSaude.tiposDeficiencias.push('Visual');
    if (!fichaSaude.id) return await ApiService.post(`FichaSaude`, fichaSaude);
    else return await ApiService.put(`FichaSaude`, fichaSaude);
  },
  async buscarPorMatriculaId(matriculaId) {
    let { data } = await ApiService.get(
      `FichaSaude?matriculaId=${matriculaId}`
    );
    data.data.deficienciaAuditiva =
      data.data.tiposDeficiencias.includes('Auditiva');
    data.data.deficienciaFisica =
      data.data.tiposDeficiencias.includes('Fisica');
    data.data.deficienciaIntelectual =
      data.data.tiposDeficiencias.includes('Intelectual');
    data.data.deficienciaMultipla =
      data.data.tiposDeficiencias.includes('Multipla');
    data.data.deficienciaPsicossocial =
      data.data.tiposDeficiencias.includes('Psicossocial');
    data.data.deficienciaVisual =
      data.data.tiposDeficiencias.includes('Visual');
    return data;
  },
};

export default FichaSaudeService;
